import { useOffersFiltersStore } from '../stores/offersFiltersStore';

export const useOffersFilters = () => {
  const filters = useOffersFiltersStore((state) => state.filters);
  const setFilters = useOffersFiltersStore((state) => state.setFilters);
  const updateFilters = useOffersFiltersStore((state) => state.updateFilters);
  const setFilter = useOffersFiltersStore((state) => state.setFilter);
  const removeFilter = useOffersFiltersStore((state) => state.removeFilter);
  const clearFilters = useOffersFiltersStore((state) => state.clearFilters);
  const getFilter = useOffersFiltersStore((state) => state.getFilter);
  const hasFilters = useOffersFiltersStore((state) => state.hasFilters());
  const hasFilter = useOffersFiltersStore((state) => state.hasFilter);

  return {
    filters,
    setFilters,
    updateFilters,
    setFilter,
    removeFilter,
    clearFilters,
    getFilter,
    hasFilters,
    hasFilter,
  };
};
